export default {
	baseUrl: 'ratefolio.petrovicstefan.rs',
	protocol: 'https://'
};
